import { render } from "./welcomeMessage.vue?vue&type=template&id=4a9ab548"
import script from "./welcomeMessage.vue?vue&type=script&lang=js"
export * from "./welcomeMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__